'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { useLanguage } from '@/contexts/LanguageContext';
import LoginModal from '@/app/components/LoginModal';
import { Clock, Users, ArrowRight } from 'lucide-react';

export default function CommunityClient() {
  const { t } = useLanguage();
  const [loginOpen, setLoginOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <Header onLoginClick={() => setLoginOpen(true)} />
      <main className="pt-16">
        {/* Page header */}
        <div style={{ backgroundColor: '#070707', borderBottom: '1px solid #111111' }}>
          <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 2xl:px-16 py-8 sm:py-10">
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, marginBottom: 12, backgroundColor: '#B8FF00', padding: '3px 10px', borderRadius: 2 }}>
              <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.12em', color: '#070707', textTransform: 'uppercase', fontFamily: 'var(--font-mono, monospace)' }}>
                {t('R3SET RUNNING', 'R3SET RUNNING')}
              </span>
            </div>
            <h1 style={{ fontFamily: 'var(--font-heading, "Arial Black", sans-serif)', fontWeight: 900, fontSize: 'clamp(1.75rem, 4vw, 2.5rem)', color: '#FFFFFF', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '-0.02em', lineHeight: 0.95 }}>
              {t('Community', '社群')}
            </h1>
            <p style={{ color: 'rgba(247,247,242,0.55)', fontSize: 13, maxWidth: 480, fontFamily: 'var(--font-body, sans-serif)', lineHeight: 1.65 }}>
              {t('A running community built for consistency, recovery, and exploration.', '一个围绕一致性、恢复和探索建立的跑步社群。')}
            </p>
          </div>
        </div>

        {/* Coming Soon state */}
        <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 2xl:px-16 py-20 sm:py-28">
          <div className="max-w-xl mx-auto text-center">
            {/* Status badge */}
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, marginBottom: 24, backgroundColor: '#EDFFD0', border: '1px solid #B8FF00', padding: '6px 14px', borderRadius: 2 }}>
              <Clock size={13} style={{ color: '#070707' }} />
              <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', color: '#070707', textTransform: 'uppercase', fontFamily: 'var(--font-mono, monospace)' }}>
                {t('Being Prepared', '准备中')}
              </span>
            </div>

            <h2 style={{ fontFamily: 'var(--font-heading, "Arial Black", sans-serif)', fontWeight: 900, fontSize: 'clamp(1.5rem, 3.5vw, 2.25rem)', color: '#070707', marginBottom: 16, textTransform: 'uppercase', letterSpacing: '-0.02em', lineHeight: 1 }}>
              {t('This section is being prepared.', '此版块正在准备中。')}
            </h2>

            <p style={{ fontSize: 15, color: '#5F625F', lineHeight: 1.7, marginBottom: 8, fontFamily: 'var(--font-body, sans-serif)' }}>
              {t(
                'Confirmed community updates will be published here soon.',
                '确认的社群动态将很快在此发布。'
              )}
            </p>
            <p style={{ fontSize: 14, color: '#5F625F', lineHeight: 1.7, marginBottom: 32, fontFamily: 'var(--font-body, sans-serif)' }}>
              {t(
                'In the meantime, join our weekly training sessions to meet the community.',
                '与此同时，加入我们的每周训练以认识社群成员。'
              )}
            </p>

            {/* Divider */}
            <div style={{ width: 48, height: 3, backgroundColor: '#B8FF00', margin: '0 auto 32px' }} />

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Link
                href="/weekly-plan"
                style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '12px 24px', backgroundColor: '#070707', color: '#FFFFFF', fontWeight: 700, fontSize: 13, textDecoration: 'none', borderRadius: 2, letterSpacing: '0.06em', textTransform: 'uppercase', fontFamily: 'var(--font-mono, monospace)', border: '2px solid #070707', transition: 'background 0.15s' }}
              >
                {t('View Weekly Plan', '查看每周计划')}
                <ArrowRight size={14} />
              </Link>
              <Link
                href="/sign-up-login"
                style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '12px 24px', backgroundColor: 'transparent', color: '#070707', fontWeight: 700, fontSize: 13, textDecoration: 'none', borderRadius: 2, letterSpacing: '0.06em', textTransform: 'uppercase', fontFamily: 'var(--font-mono, monospace)', border: '2px solid #070707', transition: 'background 0.15s' }}
              >
                <Users size={14} />
                {t('Create Account', '创建账户')}
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
      <LoginModal isOpen={loginOpen} onClose={() => setLoginOpen(false)} />
    </div>
  );
}
